import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { AppMaterialModule } from '../../../../shared/appMaterial/app-material.module';
import { SharedMessagingModule } from '../../../../shared/messaging/messaging.module';
import { CometChatCoreService } from '../../../../../core/services/cometChat/cometChatCore.service';
import { CometChatService } from '../../../../../core/services/cometChat/cometChat.service';
import { CometChatSuperAdminService } from '../../../../../core/services/cometChat/cometChatSuperAdmin.service';
import { OwnerContextComponent } from './owner.component';
import { BookingDetailsModule } from '../../../bookings-manager/booking-details-wrapper/booking-details/booking-details.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    AppMaterialModule,
    SharedMessagingModule,
    BookingDetailsModule,
  ],
  declarations: [OwnerContextComponent],
  exports: [OwnerContextComponent],
  providers: [
    CometChatCoreService,
    CometChatService,
    CometChatSuperAdminService,
  ],
})
export class OwnerContextModule {}
